import { ProductMenu } from '../product-menu';
import { MenuType } from '../../enum/dto/menu-type.enum';
import { SectionRowViewModel } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-row-view-models/SectionRowViewModel';
import { ColWidth } from '../../shared/col-width';
import type { SectionWithProducts } from '../section/section-with-products';
import { LocationPriceStream } from '../../enum/shared/location-price-stream';
import { FONT, FontStyleSheet } from '../font-style-sheets';
import { SectionColumnViewModel } from 'src/app/modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-column-view-models/SectionColumnViewModel';
import { SectionColumnProductInfoType } from '../../enum/shared/section-column-product-info-type';
import { WithinNameCell } from '../../enum/shared/within-name-cell';

export class SmallJaneMenu extends ProductMenu {
  getThemeClass(): string {
    return 'small-jane-theme' + (this.type === MenuType.WebMenu ? ' web-menu' : '');
  }

  getShowInlineLabels(): WithinNameCell {
    return WithinNameCell.TitleLine;
  }

  getSectionHeaderUnderlined(): boolean {
    return false;
  }

  getDefaultBackgroundImageUrl(): string {
    return 'assets/images/PaperTexture.png';
  }

  getPriceDecimal(
    priceStream: LocationPriceStream,
    locationId: number,
    s: SectionWithProducts,
    rowVM: SectionRowViewModel,
    colVm: SectionColumnViewModel
  ): string {
    if (!this.getDropDecimal()) {
      const price = this.getVariantPricing(priceStream, locationId, s, rowVM, colVm, false, true);
      const dec = price.split('.')?.[1];
      // decimals and formatting are included. ie: $1000.00
      if (price === '-' || price.length > 7 || dec === '') {
        return '';
      } else {
        return dec;
      }
    } else {
      return '';
    }
  }

  override getThemeSpecifiedColumnViewModels(
    sectionRowViewModels: SectionRowViewModel[],
    rowViewModel: SectionRowViewModel,
    widths: ColWidth[] = this.getColWidths(rowViewModel)
  ): SectionColumnViewModel[] {
    let vms = this.getThemeStandardizedColumnViewModels(sectionRowViewModels, rowViewModel, widths);
    // Remove big spaces
    vms = vms.filter(vm => vm.columnType !== SectionColumnProductInfoType.Spacer);
    return vms;
  }

  getColumnGroupingSpacerWidthPercentage(): number {
    return 0;
  }

  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [
      FONT.OpenSans.Regular_400,
      FONT.Poppins.Thin_100,
      FONT.Poppins.ExtraLight_200,
      FONT.Poppins.Light_300,
      FONT.Poppins.Regular_400,
      FONT.Poppins.Medium_500,
      FONT.Poppins.Bold_700
    ];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/vtb7jet.css';
  }

  override fixedLocationBrandPropertyIsWithin(): WithinNameCell | null {
    return WithinNameCell.TitleLine;
  }

  getShowProductSubtitle(): boolean {
    return false;
  }
}
